<template>
    <div>
        <psi-page-title
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
        ></psi-page-title>
        <!-- Content always starts with a v-card  -->
        <v-card class="mt-4 pa-3" height="700">
            <psi-toolbar
                :filters="[]"
                :quicklinks="[]"
                :actions="[]"
                :indicator="searchResults.length"
                hide-refresh
                :showActionMenu="false"
                :view-option.sync="viewOption"
            >
            </psi-toolbar>

            <keep-alive>
                <component
                    :loading="loading"
                    :screens="searchResults"
                    :screeners="screeners"
                    :show-select="false"
                    :is="`screening-${viewOption}`"
                ></component>
            </keep-alive>
        </v-card>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ScreeningList from "@components/screen/components/ScreeningList";
import ScreeningGrid from "@components/screen/components/ScreeningGrid";

export default {
    name: "ApplicationSearch",
    components: {
        ScreeningList,
        ScreeningGrid,
    },
    props: {},
    data() {
        return {
            viewOption: this.$vuetify.breakpoint.mobile ? "grid" : "list",
            page: {
                title: "Search Orders",
                icon: "mdi-account-search",
            },
            breadcrumbs: [
                {
                    text: "Order History",
                    disabled: false,
                    to: "/orders/history",
                },
                {
                    text: "Search Orders",
                    disabled: true,
                },
            ],
        };
    },
    watch: {
        searchTerm: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.getSearchResults(value);
                }
            },
        },
    },
    computed: {
        ...mapGetters("Screens", [
            "searchResults",
            "searchTerm",
            "screeners",
            "loading",
        ]),
    },
    methods: {
        ...mapActions("Screens", ["getSearchResults"]),
    },
};
</script>

<style scoped>
</style>